import { EntityService } from '@/services/EntityService';
import { ErrorWrapper, ResponseWrapper } from '@/services/util';

export class BuildingComplexesService extends EntityService {
  static get entity() {
    return 'building-complexes';
  }

  static async updateRelatedCompany(id, parameters = {}) {
    const params = { ...parameters };

    try {
      const response = await this.request({
        auth: true
      }).patch(`/${this.entity}/${id}/related-companies/${params.id}`, params);
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async removeRelatedCompany(id, parameters = {}) {
    const params = { ...parameters };

    try {
      const response = await this.request({ auth: true }).delete(
        `/${this.entity}/${id}/related-companies/${params.id}`
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
}
